export const INFORMACIJE_O_OBRADI_PODATAKA = 'INFORMACIJE_O_OBRADI_PODATAKA';
export const UVJETI_KORISTENJA = 'UVJETI_KORISTENJA';

export const MAIN_ATTACHMENT = 'MAIN_ATTACHMENT';
export const ATTACHMENT = 'ATTACHMENT';
